require('../../modules/es.string.code-point-at');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'codePointAt');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/string/code-point-at.js
// module id = 1226
// module chunks = 1